module.exports = __webpack_public_path__ + "img/fuli66.51baad55.png";